import React, { useEffect } from "react";
import HeaderInner from "../../Components/HeaderInner";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { getInStayRentalItemsAPI } from "../../API/InStayRentalAPI";
import CustomBusinessServiceLoader from "../../Components/Loaders/CustomBusinessServiceLoader";
import { useBusinessNameContext } from "../../context/BusinessName";
import InStayRentalPost from "../../Components/InStayRentalPost";
import { useTranslation } from "react-i18next";

function InStayRentalItems() {
  const { businessName } = useBusinessNameContext();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const category_id = params.category_id;

  const lang = sessionStorage.getItem("lang");

  const { data, isLoading, error } = useQuery(
    ["in-stay-rental-items", room_uuid, category_id, lang],
    () => getInStayRentalItemsAPI({ room_uuid, category_id, lang }),
    { enabled: !!room_uuid && !!category_id }
  );

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  if (error) {
    if (error?.response?.status === 404) {
      navigate(`/not-found`);
      return null;
    }
    return <div>Error fetching data</div>;
  }

  if (!isLoading && data?.data?.status === false) {
    navigate(`/${room_uuid}/qr-scan`);
    return null;
  }

  const responseData = data?.data?.data;
  const items = responseData?.items || [];
  const headerTitle = (
    responseData?.center_header ||
    responseData?.title ||
    "In Stay Rental"
  ).replace("In Stay", "In-Stay");

  return (
    <>
      <HeaderInner headerName={headerTitle} />

      <main className="home-main bg-white back-fe pad-top-0 car_rental">
        {isLoading ? (
          <CustomBusinessServiceLoader
            businessName={businessName}
            loader={"carRental"}
          />
        ) : items.length > 0 ? (
          <ul className="display-list car-list two-items v2">
            {items.map((item) => (
              <InStayRentalPost
                key={item.id}
                item={item}
                room_uuid={room_uuid}
              />
            ))}
          </ul>
        ) : (
          <div className="text-center py-5">
            <p>{t("No items found")}</p>
          </div>
        )}
      </main>
    </>
  );
}

export default InStayRentalItems;
